/** Matches elements that can receive focus without a temporary tabindex. */
export const FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), details, [tabindex]';
/**
 * Moves focus to an element. Non-focusable targets get tabindex="-1" when needed
 * (kept for skip links; removed after focus when `removeTabIndexAfterFocus` is set).
 */
export function focusElement(element, options = {}) {
    const { preventScroll = false, removeTabIndexAfterFocus = false } = options;
    if (element.matches(FOCUSABLE_SELECTOR)) {
        element.focus({ preventScroll });
        return;
    }
    const hadTabIndex = element.hasAttribute('tabindex');
    if (!hadTabIndex) {
        element.setAttribute('tabindex', '-1');
    }
    element.focus({ preventScroll });
    if (removeTabIndexAfterFocus && !hadTabIndex) {
        element.removeAttribute('tabindex');
    }
}
export function focusElementById(id, options) {
    const target = document.getElementById(id);
    if (!(target instanceof HTMLElement)) {
        return false;
    }
    focusElement(target, options);
    return true;
}
